export const SET_REQUEST = 'dashboard/AssociatedCompanies/SET_REQUEST'

export const SET_PAGING = 'dashboard/AssociatedCompanies/SET_PAGING'
export const SET_QUERY_FILTER = 'dashboard/AssociatedCompanies/SET_QUERY_FILTER'
